/**
 * A storage reader reads storage via a device interface
 * given a specific version of SNJS
 */
export class StorageReader {
    constructor(deviceInterface, identifier, environment) {
        this.deviceInterface = deviceInterface;
        this.identifier = identifier;
        this.environment = environment;
    }
    static version() {
        throw Error('Must override');
    }
}
